import styled from '@emotion/styled';

export const BorderButton = styled.button`
  display: flex;
  width: fit-content;
  align-items: center;
  padding: 4px 8px;
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 4px;
  gap: 4px;

  transition: all 0.15s ease-in-out;

  &:hover {
    cursor: pointer;
  }

  &.is-disabled {
    border: none;
    background-color: transparent;
    color: ${({ theme }) => theme.colors.zinc_300};
  }
`;

export const GrayBorderButton = styled(BorderButton)`
  border: 1px solid ${({ theme }) => theme.colors.zinc_200};
  color: ${({ theme }) => theme.colors.zinc_500};

  &:hover {
    background-color: ${({ theme }) => theme.colors.zinc_100};
  }
`;

export const RedBorderButton = styled(BorderButton)`
  border: 1px solid ${({ theme }) => theme.colors.cerise_100};
  color: ${({ theme }) => theme.colors.cerise_300};

  &:hover {
    background-color: ${({ theme }) => theme.colors.cerise_50};
  }
`;
